import { computed } from "vue";
import { useStore } from "vuex";

import { CampaignGetters } from "@/store/modules/campaign";
import type { RootState } from "@/store/types";

export function useMasterTemplates() {
    const store = useStore<RootState>();

    const masterTemplates = computed(() => store.state.campaign.normalized.masterTemplates);
    const masterTemplateLabels = computed(
        () => (store.getters as Record<string, unknown>)[CampaignGetters.masterTemplateLabels] as Record<string, string>
    );
    const masterTemplateIds = computed(() => store.state.campaign.normalized.masterTemplateIds);

    return {
        masterTemplates,
        masterTemplateLabels,
        masterTemplateIds
    };
}
